import { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Custom colored pin (avoids default broken-marker asset in bundlers)
const makeIcon = (color) => new L.DivIcon({
  className: "custom-pin",
  html: `<div style="width:28px;height:28px;background:${color};border:3px solid white;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 4px 12px rgba(0,0,0,0.3);"></div>`,
  iconSize: [28, 28], iconAnchor: [14, 28], popupAnchor: [0, -28],
});

const pickupIcon = makeIcon("#081537");
const dropIcon = makeIcon("#DC2626");

function FitBounds({ pts }) {
  const map = useMap();
  useEffect(() => {
    if (pts.length === 2) {
      const b = L.latLngBounds(pts);
      map.fitBounds(b, { padding: [40, 40] });
    } else if (pts.length === 1) {
      map.setView(pts[0], 14);
    }
  }, [pts, map]);
  return null;
}

export default function RouteMap({ pickup, drop }) {
  const pts = useMemo(() => {
    const arr = [];
    if (pickup?.lat && pickup?.lon) arr.push([pickup.lat, pickup.lon]);
    if (drop?.lat && drop?.lon) arr.push([drop.lat, drop.lon]);
    return arr;
  }, [pickup, drop]);

  const center = pts[0] || [9.9312, 76.2673]; // Kochi

  return (
    <div className="w-full h-72 sm:h-80 rounded-2xl overflow-hidden border border-slate-200" data-testid="route-map">
      <MapContainer center={center} zoom={12} scrollWheelZoom={false} className="w-full h-full">
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {pickup?.lat && (
          <Marker position={[pickup.lat, pickup.lon]} icon={pickupIcon}>
            <Popup>Pickup: {pickup.address}</Popup>
          </Marker>
        )}
        {drop?.lat && (
          <Marker position={[drop.lat, drop.lon]} icon={dropIcon}>
            <Popup>Drop: {drop.address}</Popup>
          </Marker>
        )}
        {pts.length === 2 && (
          <Polyline positions={pts} pathOptions={{ color: "#081537", weight: 4, dashArray: "8 8" }} />
        )}
        <FitBounds pts={pts} />
      </MapContainer>
    </div>
  );
}
